import React, { useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Icon, Loader } from 'semantic-ui-react'
import { FarmerCreateOptionsType, FarmersService } from '~/api/services/farmers'
import { Farmer } from '~/api/services/individualFilters'
import { FormFields } from '~/components/FormFields'
import InfitiveScrollDropown from '~/components/InfitiveScrollDropown'
import notify from '~/components/Notify'

interface Props {
  farmerOptions: FarmerCreateOptionsType
  farmersList: Farmer[]
}

const FirstRow:React.FC<Props> = ({ farmerOptions, farmersList }) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { control, getValues, setValue, formState: { dirtyFields } } = useFormContext()

  const [loadingSupplierCheckNo, setLoadingSupplierCheckNo] = useState(false)
  const [correctSupplierNo, setCorrectSupplierNo] = useState(true)

  const uniqueValidationMessage = t('Please enter unique supplier number')
  const watchSupplierNo = useWatch({ control, name: 'supplierNo' })
  const watchParentId = useWatch({ control, name: 'parentId' })
  const watchFarmerType = useWatch({ control, name: 'farmerType' })

  useEffect(() => {
    if (watchFarmerType && watchFarmerType === 'main') {
      setValue('parentId', null)
    }
  }, [watchFarmerType])

  async function checkSupplierNo(value) {
    setValue('supplierNo', value)
    setLoadingSupplierCheckNo(true)
    try {
      const payload = id ? { supplierNo: value, id } : { supplierNo: value }
      const response = await FarmersService.checkSupplierNo({ ...payload })
      setCorrectSupplierNo(Boolean(response.data))
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setLoadingSupplierCheckNo(false)
  }

  return <>
    <FormFields.Input
      control={control}
      name={'supplierNo'}
      placeholder={t('Suplier no.')}
      onChange={(e, data) => checkSupplierNo(data.value)}
      rules={{
        required: true,
        validate: () => !watchSupplierNo || watchSupplierNo === '' ? true : correctSupplierNo || uniqueValidationMessage
      }}
      label={<label style={{ display: 'flex', position: 'relative' }}>
        <div>{t('Suplier no.')}<span style={{ color: 'red' }}>*</span></div>
        {loadingSupplierCheckNo && <div className='loaderWrapper'>
          <Loader size='small' active={loadingSupplierCheckNo} />
        </div>}
        {!loadingSupplierCheckNo && watchSupplierNo !== '' && dirtyFields?.supplierNo && <Icon
          style={{ marginLeft: 10 }}
          name={correctSupplierNo ? 'checkmark' : 'close'}
          color={correctSupplierNo ? 'green' : 'red'}
        />}
      </label>}
    />
    <FormFields.Input
      control={control}
      name={'companyName'}
      rules={{
        required: {
          value: true,
          message: t('Plese enter company name')
        }
      }}
      placeholder={t('Company name')}
      label={t('Company name')}
    />
    <FormFields.Select
      control={control}
      name={'farmerType'}
      label={t('Farmer type')}
      selectOnBlur={false}
      rules={{
        required: {
          value: true,
          message: t('Please select farmer type')
        }
      }}
      placeholder={t('Select farmer type')}
      options={farmerOptions?.farmerTypes?.map(farmerType => ({ value: farmerType.key, text: farmerType.label })) || []}
    />
    {(watchFarmerType === 'sub' || !!watchParentId) && <InfitiveScrollDropown
      control={control}
      selectOnBlur={false}
      name={'parentId'}
      label={t('Main farmer')}
      value={getValues('parentId')}
      rules={{
        required: {
          value: true,
          message: t('Please select main farmer')
        }
      }}
      setValue={setValue}
      placeholder={t('Select main farmer')}
      options={farmersList.map(farmer => ({ value: farmer.id, text: farmer.companyName })) || []}
    />}
  </>
}
export default FirstRow